import { render, staticRenderFns } from "./CadastroDetran.vue?vue&type=template&id=6a3876d4&scoped=true"
import script from "./CadastroDetran.vue?vue&type=script&lang=js"
export * from "./CadastroDetran.vue?vue&type=script&lang=js"
import style0 from "./CadastroDetran.vue?vue&type=style&index=0&id=6a3876d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a3876d4",
  null
  
)

export default component.exports